module.exports = require("@jswf/manager");;